__turbopack_context__.v({
  "authentication-button": "qyGU8q_authentication-button",
  "authentication-button-login": "qyGU8q_authentication-button-login",
  "authentication-button__icon": "qyGU8q_authentication-button__icon",
  "mobile-authentication-button": "qyGU8q_mobile-authentication-button",
});
